<template>
  <div class="importBtns">
    <v-btn
      v-if="importTabIndex > 0"
      outlined
      color="primary"
      class="mr-4"
      @click="onButtonClick('cancel')"
    >
      Cancel
    </v-btn>

    <v-btn v-if="importTabIndex === 0" depressed color="primary" @click="onButtonClick('start')">
      Start import
    </v-btn>

    <v-btn
      v-if="importTabIndex > 0 && importTabIndex < 3"
      depressed
      color="primary"
      @click="onButtonClick('validate')"
      :disabled="!!startImportErrors || processed"
    >
      Validate data
    </v-btn>

    <v-btn
      v-if="importTabIndex === 2"
      depressed
      color="primary"
      class="ml-4"
      @click="onButtonClick('save')"
      :disabled="saveDisabled || processed"
    >
      Save import
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ImportBtns',
  props: {
    importTabIndex: Number,
    importKey: String,
    errorList: Array,
    isFormValid: Boolean,
    startImportErrors: Number,
    enableNextOnValidation: Boolean,
    processed: Boolean,
  },

  data() {
    return {};
  },

  computed: {
    saveDisabled() {
      let result = false;
      this.errorList.forEach((err) => {
        if (err.Error < 100) result = true;
      });
      return result;
    },
  },

  methods: {
    onButtonClick(val) {
      this.$emit('buttonClick', val);
    },
  },
};
</script>

<style></style>
